<template>
  <router-view/>
</template>

<script>
  import { onMounted } from "vue";
  import AOS from "aos";

  export default {
    name: 'App',
    setup() {
      onMounted(() => {
        AOS.init({
          duration: 1200,
        });
      });
    }
  }
</script>

